import styled from 'styled-components';
import { media, fonts, mixins } from '../../../css';
import Base from '../Base/Base';

// eslint-disable-next-line
export const StyledHeadingFirst = styled(Base)`
  font-family: ${fonts.fontBold};
  font-size: ${mixins.pxToRem(26)};
  line-height: ${mixins.pxToRem(32)};
  text-align: ${(props) => props.align};
  text-transform: ${(props) => props.textTransform};
  color: ${(props) => props.color};
  margin: ${(props) => (props.noMargins === false ? `${mixins.pxToRem(5)} 0 ${mixins.pxToRem(10)}` : 0)};

  a {
    text-decoration: none;
    color: inherit;
    &:hover {
      text-decoration: underline;
    }
  }

  ${media.greaterThan('lg')`
    font-size: ${mixins.pxToRem(40)};
    line-height: ${mixins.pxToRem(48)};
    letter-spacing: 1px;
    margin: ${(props) => (props.noMargins === false ? `${mixins.pxToRem(10)} 0 ${mixins.pxToRem(15)}` : 0)};
  `};
`;
